import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { servicesPage } from '../../data/mock';
import { TrendingUp, Users } from 'lucide-react';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Footer from '../../components/layout/Footer';

const Services = () => {
  const { language } = useLanguage();
  const services = servicesPage[language];

  return (
    <div className="min-h-screen relative">
      {/* Split background - stacks on mobile */}
      <div className="absolute inset-0 flex flex-col md:flex-row">
        <div
          className="flex-1 bg-cover bg-center relative"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80')`,
          }}
        >
          <div className="absolute inset-0 bg-[#1a2a3a]/60" />
        </div>
        <div
          className="flex-1 bg-cover bg-center relative"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&q=80')`,
          }}
        >
          <div className="absolute inset-0 bg-[#1a2a3a]/60" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 pt-24 pb-16 sm:pt-20">
        <AnimateOnScroll animation="fadeInUp">
          <h1 className="text-white text-3xl sm:text-5xl md:text-6xl font-light italic mb-4 sm:mb-6 text-center">
            {services.title}
          </h1>
        </AnimateOnScroll>
        <AnimateOnScroll animation="fadeInUp" delay={200}>
          <p className="text-white/80 text-lg sm:text-xl md:text-2xl font-light text-center max-w-3xl mb-12 sm:mb-20">
            {services.subtitle}
          </p>
        </AnimateOnScroll>

        {/* Services grid */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-10 sm:gap-8 md:gap-32 w-full max-w-5xl">
          {/* Investment */}
          <AnimateOnScroll animation="scaleIn" delay={400} className="flex-1">
            <Link
              to="/servicios/inversion"
              className="group flex flex-col items-center"
            >
            <div className="relative w-36 h-36 sm:w-48 sm:h-48 mb-6 sm:mb-8">
              <div className="absolute inset-0 rounded-full border-2 border-white/40 group-hover:border-[#3eb8b3] transition-all duration-500" />
              <div className="absolute inset-4 sm:inset-6 rounded-full border border-dashed border-white/20 group-hover:border-[#3eb8b3]/50 transition-all duration-500" style={{ animation: 'spin 20s linear infinite' }} />
              <div className="absolute inset-0 flex items-center justify-center">
                <TrendingUp className="text-white group-hover:text-[#3eb8b3] transition-colors duration-300" size={40} strokeWidth={1} />
              </div>
            </div>
            <button className="hover-glow bg-white/10 backdrop-blur-sm text-white px-6 sm:px-12 py-3 sm:py-4 text-sm sm:text-lg tracking-widest border border-white/30 hover:bg-[#3eb8b3] hover:border-[#3eb8b3] transition-all duration-300">
              {services.investment.title.toUpperCase()}
            </button>
          </Link>
          </AnimateOnScroll>

          {/* Management */}
          <AnimateOnScroll animation="scaleIn" delay={600} className="flex-1">
            <Link
              to="/servicios/gestion"
              className="group flex flex-col items-center"
            >
            <div className="relative w-36 h-36 sm:w-48 sm:h-48 mb-6 sm:mb-8">
              <div className="absolute inset-0 rounded-full border-2 border-white/40 group-hover:border-[#3eb8b3] transition-all duration-500" />
              <div className="absolute inset-4 sm:inset-6 rounded-full border border-dashed border-white/20 group-hover:border-[#3eb8b3]/50 transition-all duration-500" style={{ animation: 'spin 20s linear infinite reverse' }} />
              <div className="absolute inset-0 flex items-center justify-center">
                <Users className="text-white group-hover:text-[#3eb8b3] transition-colors duration-300" size={40} strokeWidth={1} />
              </div>
            </div>
            <button className="hover-glow bg-white/10 backdrop-blur-sm text-white px-6 sm:px-12 py-3 sm:py-4 text-sm sm:text-lg tracking-widest border border-white/30 hover:bg-[#3eb8b3] hover:border-[#3eb8b3] transition-all duration-300">
              {services.management.title.toUpperCase()}
            </button>
          </Link>
          </AnimateOnScroll>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Services;
